import(/* webpackMode: "eager" */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\components\\frontend\\home\\BlogSlider.tsx");
